var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverworkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 136.639,
    height: 135.999,
    viewBox: "0 0 136.639 135.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7143",
    "data-name": "Group 7143",
    transform: "translate(-1228 -515.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7142",
    "data-name": "Group 7142",
    transform: "translate(298.74 476.718)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9357",
    "data-name": "Path 9357",
    d: "M952.815,39.818a129.075,129.075,0,0,0-16.345-1.036V77.011a91.073,91.073,0,0,1,11.517.731Z",
    fill: "#1d3445",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9358",
    "data-name": "Path 9358",
    d: "M990.88,50.773a129.466,129.466,0,0,0-26.259-8.893l-8.315,37.314a91.127,91.127,0,0,1,18.5,6.267Z",
    fill: "#1d4f59",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9359",
    "data-name": "Path 9359",
    d: "M1026.126,74.863a129.424,129.424,0,0,0-24.53-18.5L982.36,89.4a91.074,91.074,0,0,1,17.284,13.038Z",
    fill: "#1d6a6c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9360",
    "data-name": "Path 9360",
    d: "M1054.08,114.175a129.372,129.372,0,0,0-20.071-31.04L1005.2,108.263a91.191,91.191,0,0,1,14.142,21.874Z",
    fill: "#1d867f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9361",
    "data-name": "Path 9361",
    d: "M1065.9,168.263a129.428,129.428,0,0,0-6.965-41.938L1022.763,138.7a91.2,91.2,0,0,1,4.908,29.55Z",
    fill: "#1da193",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9362",
    "data-name": "Path 9362",
    d: "M940.338,162.394h-5.454l1.364-71.912h2.727Z",
    fill: "#1d3943",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9363",
    "data-name": "Path 9363",
    d: "M941.8,169.181v-6.039l55.606,1.509v3.02Z",
    fill: "#1d3943",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2578",
    "data-name": "Rectangle 2578",
    width: 11.735,
    height: 11.735,
    transform: "translate(929.26 166.483) rotate(-45)",
    fill: "#323338"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverworkIcon);
export default __webpack_public_path__ + "static/media/overwork_icon.b05e83d0f0297e029ee70c21ae31b2c4.svg";
export { ForwardRef as ReactComponent };